import { Settings } from './Settings';
export class PrimarySettings extends Settings {
    private hasSeenMoreContent : string = "hasSeenMoreContent";
    constructor(primarySettingsObject : any ){
        super(primarySettingsObject);
    }
    hasSeenContent() : boolean {
        return this.getParam(this.hasSeenMoreContent);
    }
    setSeenMoreContent(seenMoreContent = true){
        this.setParam(this.hasSeenMoreContent,seenMoreContent);
    }
}